import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { HTTP_INTERCEPTORS, HttpClientModule, HttpClientXsrfModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'; // Required for animations
import { ToastrModule } from 'ngx-toastr';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacyTableModule as MatTableModule } from '@angular/material/legacy-table';
import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';
import { MatSortModule } from '@angular/material/sort';
import { MatLegacyPaginatorModule as MatPaginatorModule } from '@angular/material/legacy-paginator'; // MatPaginatorModule
import { ApplicationPageWithMenuModule } from './application-page-with-menu/application-page-with-menu.module';
import { SharedModule } from './shared/shared.module';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker'; // BsDatepickerModule
import { DatePipe } from '@angular/common';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { PipesModule } from './pipes/pipes.module';
import { NgChartsModule } from 'ng2-charts';
import { FormsModule } from '@angular/forms';
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';
import { MatLegacyOptionModule as MatOptionModule } from '@angular/material/legacy-core';

import { ToastrService } from 'ngx-toastr';
import { MatLegacySnackBarModule as MatSnackBarModule } from '@angular/material/legacy-snack-bar';
import { AuthService } from './shared/services/auth.service';
import { HttpInterceptorService } from '../app/shared/services/http-interceptor.service'; // Add Interceptor

import { AppComponent } from './app.component';
import { ApplicationPageWithMenuComponent } from './application-page-with-menu/application-page-with-menu.component';
import { DashboardComponent } from './application-page-with-menu/dashboard/dashboard.component';
import { PizzaPieChartComponent } from './pizza-pie-chart/pizza-pie-chart.component';
// import { FranchiseManagementComponent } from './application-page-with-menu/franchise-management/franchise-management.component';
import { UserManagementComponent } from './application-page-with-menu/user-management/user-management.component';
// import { StoreManagementComponent } from './application-page-with-menu/store-management/store-management.component';
// import { CampaignManagementComponent } from './application-page-with-menu/campaign-management/campaign-management.component';
import { BillingGroupComponent } from './application-page-with-menu/billing-group/billing-group.component';
import { LoginComponent } from './application-page/login/login.component';
import { LogoutComponent } from './application-page/logout/logout.component';
import { HeaderComponent } from './application-page/header/header.component';
import { ResetPasswordComponent } from './application-page/reset-password/reset-password.component';
import { MenusWithNavigationsComponent } from './application-page/header/menus-with-navigations/menus-with-navigations.component';
import { ForgetPasswordComponent } from './application-page/forget-password/forget-password.component';
import { MatIconModule } from '@angular/material/icon';
import { LoaderComponent } from './loader/loader.component';
import { UatFlagComponent } from './uat-flag/uat-flag.component';

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    // ApplicationPageWithMenuComponent,
    DashboardComponent,
    PizzaPieChartComponent,
    // FranchiseManagementComponent,
    UserManagementComponent,
    // StoreManagementComponent,
    // CampaignManagementComponent,
    BillingGroupComponent,
    LogoutComponent,
    HeaderComponent,
    ResetPasswordComponent,
    MenusWithNavigationsComponent,
    ForgetPasswordComponent,
    LoaderComponent,
  ],
  imports: [
    UatFlagComponent,
    BrowserModule,
    SharedModule,
    AppRoutingModule,
    HttpClientModule,
    HttpClientXsrfModule.withOptions({ cookieName: 'XSRF-TOKEN', headerName: 'X-XSRF-TOKEN' }),
    FormsModule,
    NgChartsModule,
    MatTooltipModule,
    BrowserAnimationsModule,
    MatFormFieldModule,
    MatTableModule,
    MatDialogModule,
    MatButtonModule,
    MatSortModule,
    MatPaginatorModule,
    MatSnackBarModule,
    MatIconModule,
    MatSelectModule,
    MatOptionModule,
    PipesModule,
    BsDatepickerModule.forRoot(), // Initialize BsDatepickerModule
    // ApplicationPageWithMenuModule,
    ToastrModule.forRoot({
      timeOut: 3000,
      positionClass: 'custom-toast-position',
      // preventDuplicates: true,
      enableHtml: true // Allow HTML content in toastr message
    })
  ],
  exports: [
  ],
  providers: [
    ToastrService,
    DatePipe,
    AuthService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpInterceptorService, 
      multi: true
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
